import React, { useMemo, useState } from 'react';
// import Button from '../../../../ui-core/Button/Button'
import { Form } from 'react-bootstrap';
import clsx from 'clsx';
import {
  IMAGE_CONSTANT,
  LOCAL_STORAGE_CONSTANT,
  SIGNUP_ONBOARDING,
  TEXT_CONSTANT,
} from '../../../../constants/app';
import {
  getDisplayType,
  getUserAttribute,
  isValidateEmail,
} from '../../../../utils/helpers';
import useWindowWidth from '../../../../hooks/useWindowWidth';
import CustomButton from '../../../../ui-core/Button/Button';
import { getItem, removeItem, setItem } from '../../../../utils/cache';
import { APP_ROUTES } from '../../../../route';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../../../../services/Notification';
import { checkUniqueEmail } from '../../../Profile/PersonalDetails';
import './../../../FitnessOptions/SignupOnboarding/style.css';
import { useCourseDetail } from '../../../../hooks/useCourseDetail';
import PropTypes from 'prop-types';
import { extractJSON } from '../../../../services/jsonUtil';
import { updateUserProfileRequest } from '../../../../api/user';
import { useModal } from '../../../../context/ModalContext';
// import Loader from '../../../../ui-core/Loader';

const NameModal = ({ history, match = {} }) => {
  const [stepIndex, setStepIndex] = useState(0);
  const displayType = getDisplayType(useWindowWidth());
  const isMobileScreen = displayType === 'mobile';
  const isIpadScreen = displayType === 'ipad';
  const email = getUserAttribute('email');
  const name = getUserAttribute('name');
  const [state, setState] = useState({
    name: name || '',
    email: email || '',
  });
  // const localMatch = extractJSON('localMatch');

  const { handleCourseRedirection } = useCourseDetail(
    history /* , match || localMatch */,
  );
  const { modalState, closeModal } = useModal();

  const totalSteps = useMemo(() => {
    const steps = Array.from({
      length: 2,
    }).map((_, index) => index + 1);

    return steps;
  }, [window.location.search]);

  const renderQuestions = () => {
    switch (totalSteps[stepIndex]) {
      case SIGNUP_ONBOARDING.name:
        return TEXT_CONSTANT.DEFAULT_ONBOARDING_QUESTIN_FOR_NAME;
      case SIGNUP_ONBOARDING.email:
        return TEXT_CONSTANT.DEFAULT_ONBOARDING_QUESTIN_FOR_EMAIL;
      default:
        return null;
    }
  };

  const renderContent = () => {
    switch (totalSteps[stepIndex]) {
      case SIGNUP_ONBOARDING.name:
        return (
          <Form.Control
            name="name"
            onChange={handleChange}
            className="form-control-name"
            placeholder="Type Here"
            value={state?.name}
            maxLength={30}
            onKeyDown={handleGoNext}
          />
        );
      case SIGNUP_ONBOARDING.email:
        return (
          <>
            <Form.Control
              name="email"
              onChange={handleChange}
              className={`form-control-name ${state.error ? 'm-0' : ''} `}
              placeholder="Type Here"
              value={state?.email}
              maxLength={50}
              onKeyDown={handleGoNext}
            />
            {state.error && (
              <div
                className="error-message mt-3"
                style={{ marginBottom: '90px' }}
              >
                {state.error}
              </div>
            )}
          </>
        );
      default:
        return null;
    }
  };

  const handleGoNext = event => {
    if (event.keyCode === 13 && !isDisabled) {
      handleSubmit();
    }
  };

  const handleGoBack = () => {
    if (totalSteps[stepIndex] === 1) {
      const localSlug = getItem('localSlug');
      if (localSlug) {
        // JW-248, JW-249
        history.push('/' + localSlug);
        removeItem('redirectToCourse');
        removeItem('localMatch');
        removeItem('localSlug');
        // removeItem('isFromCoursePage');
      } else {
        history.push(APP_ROUTES.HOME);
      }
    }
    setStepIndex(prev => (prev - 1 >= 0 ? prev - 1 : prev));
  };
  const percentageWidth =
    (((stepIndex + 1) / totalSteps.length) * 100).toFixed(2) + '%';

  const handleChange = e => {
    const key = e.target.name;
    const value = e.target.value;
    setState({
      ...state,
      [key]: value,
    });
    if (key === 'email' && !isValidateEmail(value)) {
      // Set an error message for invalid email
      setState({
        ...state,
        [key]: value,
        error: `You've entered an invalid email, please try another one.`,
      });
    } else {
      setState({ ...state, [key]: value, error: null });
    }
  };

  const isDisabled = useMemo(() => {
    switch (totalSteps[stepIndex]) {
      case SIGNUP_ONBOARDING.name:
        return state?.name?.trim().length === 0;
      case SIGNUP_ONBOARDING.email:
        return (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(state?.email) ||
          state?.email.trim() === 0
        );
      default:
        return false;
    }
  }, [stepIndex, state, totalSteps]);

  const handleSubmit = async () => {
    const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    if (totalSteps[stepIndex] === SIGNUP_ONBOARDING.email) {
      const error = await checkUniqueEmail(state?.email);
      if (error) {
        createNotification({
          type: NOTIFICATION_TYPE.ERROR,
          message: 'Email has already been taken',
        });
        return;
      }
    }

    if (stepIndex < totalSteps.length - 1) {
      setStepIndex(prev => prev + 1);
      setItem(
        'obDetails',
        JSON.stringify({ name: state.name, email: state.email }),
      );
    } else {
      setItem(
        'obDetails',
        JSON.stringify({ name: state.name, email: state.email }),
      );
      updateUserProfileRequest(user?.id, {
        ...user.attributes,
        name: state.name,
      });

      await handleCourseRedirection();

      if (closeModal && modalState) {
        closeModal();
      }
    }
  };

  return (
    <>
      <div className={clsx('quest-page')}>
        <React.Fragment>
          <div className="d-flex justify-content-between md:mt-4 mb-3">
            {totalSteps[stepIndex] === SIGNUP_ONBOARDING.email && (
              <button
                onClick={handleGoBack}
                className="d-flex justify-content-sm-start align-items-center quest-back-section cursor-pointer btn bg-transparent shadow-none p-0"
                // disabled={totalSteps[stepIndex] === 1}
              >
                <img
                  className="cursor-pointer"
                  src={IMAGE_CONSTANT.backIcon}
                  alt="back"
                />
                <span>BACK</span>
              </button>
            )}
          </div>
          <div className="new-progress-bar">
            <div
              className="filled-area"
              style={{ width: percentageWidth }}
            ></div>
          </div>
          <h2
            className={clsx(
              'quest-h2',
              isMobileScreen && '',
              isIpadScreen && '',
            )}
          >
            {renderQuestions()}
          </h2>
        </React.Fragment>
      </div>
      {renderContent()}
      <div className={clsx('question-sticky-btn-wrapper d-flex')}>
        <CustomButton
          text={
            <div>
              NEXT{' '}
              <span style={{ fontSize: '25px', fontWeight: '400' }}>{'>'}</span>
            </div>
          }
          isDisabled={isDisabled}
          class={'question-fill-button'}
          // isLoading={isLoading || loading}
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};

NameModal.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object,
};

export default NameModal;
